import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { id: "app" } },
    [
      _vm.viewShow ? _c("router-view", { key: _vm.refreshKey }) : _vm._e(),
      _vm._v(" "),
      _c("LottieLoader", {
        attrs: {
          show: _vm.showLoader,
          "animation-data": require("@/assets/json/lottie/loaders/open-book-loader.json"),
          "overlay-color": "#21212155",
          overlay: "",
          center: "",
          fullscreen: "",
        },
      }),
      _vm._v(" "),
      _c("ReportDialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }